import * as Sentry from '@sentry/browser';
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';
import 'alpinejs';
import amplitude from "./local-site/amplitude";

Sentry.init({
    dsn: 'https://675c95565bc422db841155a0bcffdac6@o4508001537032192.ingest.de.sentry.io/4508002631549008',
    release: COMMIT_HASH || '',
    ignoreErrors: [
        // swiper slider error
        'Swiper is not defined',
        // google chrome error for users who block all cookies in browser
        "SecurityError: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
        // Random plugins/extensions
        'top.GLOBALS',
        // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'http://tt.epicplay.com',
        'Can\'t find variable: ZiteReader',
        'jigsaw is not defined',
        'ComboSearch is not defined',
        'http://loading.retry.widdit.com/',
        'atomicFindClose',
        // Facebook borked
        'fb_xd_fragment',
        // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
        // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
        'bmi_SafeAddOnload',
        'EBCallBackMessageReceived',
        // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
        'conduitPage',
        // Generic error code from errors outside the security sandbox
        // You can delete this if using raven.js > 1.0, which ignores these automatically.
        'Script error.',
        /\$zopim/,
    ],
    ignoreUrls: [
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
    ]
});
window.jQuery = window.$ = require('jquery');
//create new instance of amplitude js object for interacting with the Amplitude browser SDK
window.amplitude = new amplitude();

/*
 * GLOBAL VARIABLES
 */
window.cookieName = 'thimbl2025';
window.expirySeconds = 3600;

require('bootstrap');
// require("../js/external-scripts/velocity.ui.js");
import "../js/external-scripts/numeric.js";
import "../js/external-scripts/rangeslider.min.js";
import "../js/external-scripts/matchmedia.js";
import "../js/external-scripts/bootstrap-datepicker.js";
import "../js/external-scripts/mailcheck.min.js";
import "../js/local-site/common.js";
import "./local-site/mega-menu.js";
import "../js/local-site/swifto-like-box.js";
import "../js/local-site/swifto-newsletter.js";
import "../js/local-site/swifto-social-share.js";

// Import components - Requires alpine js
import '../js/components/amount-plus-minus';
import '../js/components/eligibility-meter';
import '../js/components/sort-code';